module.exports = __webpack_public_path__ + "static/media/4.fea0933a.png";